import React from 'react';
import './skills.css';
import Python from '../../assets/python.png';
import TensorFlow from '../../assets/tensorflow.png';
import Pandas from '../../assets/pandas.png';
import SciKitLearn from '../../assets/scikitlearn.png';
import Numpy from '../../assets/numpy.png';
import SQL from '../../assets/SQL.png';
import HTML from '../../assets/html.png';
import JavaScript from '../../assets/javascript.png';
import react from '../../assets/react.png';
import NodeJS from '../../assets/html.png';
import Git from '../../assets/git.png';
import Rust from '../../assets/Rust.png';


const Skills = () => {
    const libraries = [
        { name: "Python", img: Python },
        { name: "TensorFlow", img: TensorFlow },
        { name: "Pandas", img: Pandas },
        { name: "SQL", img: SQL },
        { name: "Scikit-Learn", img: SciKitLearn },
        { name: "NumPy", img: Numpy },
        { name: "HTML", img: HTML },
        { name: "JavaScript", img: JavaScript },
        { name: "React", img: react},
        { name: "Node.js", img: NodeJS },
        { name: "Git", img: Git },
        { name: "Rust", img: Rust },
    ];

    return (
        <section id='skills'>
            <h1 className='skillTitle'>Full Stack Data Scientist</h1>
            <p className='skillDesc'>My Current Technologies</p>
            <div className='skillBars'>
                {libraries.map((lib, index) => (
                    <div key={index} className='skillBar'>
                        <h2>{lib.name}</h2>
                        <img src={lib.img} alt={lib.name} className="skillBarImg"/>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Skills;
